/* eslint-disable no-shadow */
import { EVENT_GET_FREE_APPOINTMENTS_BY_EVENT_ID } from './getters.type';
import { EVENT_CREATE_EVENT_APPOINTMENT } from './actions.type';
import { APIGET, APIPOST } from '../utils/apiHelper';

// initial state
const state = {
  //
};

// getters
const getters = {
  //
};

// actions
const actions = {
  async [EVENT_GET_FREE_APPOINTMENTS_BY_EVENT_ID](context, eventId) {
    try {
      const response = await APIGET(`services/Event/ListFreeEventAppointments/${eventId}/hu`);
      if (response) {
        return response;
      }
      return { error: true, message: 'HIBA' };
    } catch (err) {
      return { error: true, message: 'HIBA' };
    }
  },
  async [EVENT_CREATE_EVENT_APPOINTMENT](context, payload) {
    const json = JSON.stringify(payload.bookingForm);
    const formData = new FormData();
    formData.append('data', json);
    try {
      const response = await APIPOST(`services/Event/CreateEventAppointment/${payload.lang}`, formData);
      if (response) {
        return response;
      }
      return { error: true, message: 'HIBA' };
    } catch (err) {
      return { error: true, message: 'HIBA' };
    }
  },
};

// mutations
const mutations = {
  //
};

export default {
  state,
  getters,
  actions,
  mutations,
};
